<template>
  <div class="app-container">
    <div style="position: absolute;top: 70px;left: 650px;" v-if="active == 'ownerRentRecord'">
      <el-alert title="注：添加出租记录后自动生成收租记录，以首次收租日期为及准，按开始至结束日期间隔月数及支付类型生成！" type="success" show-icon></el-alert>
    </div>
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active" @tab-click="tabClick" v-if="showTabs">
          <el-tab-pane label="合同明细" name="ownerRentRecord">
            <owner-rent-record ref="ownerRentRecord" :house-id="houseId" :houses="houses" :nowContractId="nowContractId"></owner-rent-record>
          </el-tab-pane>
          <el-tab-pane label="交租记录" name="ownerCollectRecord">
            <owner-collect-record ref="ownerCollectRecord" :house-id="houseId" :houses="houses" :owner-ren-records="ownerRentRecords"></owner-collect-record>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import OwnerRentRecord from "@/components/OwnerRentRecord";
import OwnerCollectRecord from "@/components/OwnerCollectRecord";
import {getList as getHouses} from "@/api/house";
import {getList as getOwnerRentRecords} from "@/api/ownerRentRecord";

export default {
  components: {
    OwnerRentRecord,
    OwnerCollectRecord
  },
  data() {
    return {
      active: 'ownerRentRecord',
      houseId: 0,
      nowContractId: 0,
      houses: [],
      ownerRentRecords: [],
      showTabs: false
    }
  },
  mounted() {
    this.houseId = parseInt(this.$route.query.houseId)
    if (this.$route.query.nowContractId) {
      this.nowContractId = parseInt(this.$route.query.nowContractId)
    }
    setTimeout(() => {
      this.showTabs = true
    }, 100)
    this.getHouses()
    this.getOwnerRentRecords()
  },
  methods: {
    getHouses() {
      getHouses().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.houses = response.data
        }
      })
    },
    getOwnerRentRecords() {
      const params = {
        roomId: this.roomId
      }
      getOwnerRentRecords(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.ownerRentRecords = response.data
        }
      })
    },
    tabClick() {
      const tab = this.active
      if (tab == 'ownerRentRecord') {
        this.$refs['ownerRentRecord'].search(true)
      } else if (tab == 'ownerCollectRecord') {
        this.$refs['ownerCollectRecord'].search(true)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/houseOwner.vue